export const LEGAL_AGENT_ACTIVITY_PATH = '/agents/legal/activity';
